import React from "react";
import BackButton from "../../generic/elements/backbutton/BackButton";
import OrganizationVisibilityForm from "./OrganizationVisibilityForm";
import "./organizationcreation.css";
import { useLocation } from "react-router";
import TemplateCreatorWrapper from "./TemplateCreatorWrapper";
import InviteUsers from "./InviteUsers";
import ThemeCreator from "./ThemeCreator";
import AddDefaultForms from "./AddDefaultForms";

const OrganizationCreation = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const organizationIdentifier = params.get("organizationId");

  return (
    <section className="section-content">
      <div className="form-renderer-back-button">
        <BackButton />
        <p>Manage Organization</p>
      </div>
      <ThemeCreator organizationIdentifier={organizationIdentifier} />
      <TemplateCreatorWrapper organizationIdentifier={organizationIdentifier} />
      <AddDefaultForms organizationIdentifier={organizationIdentifier} />
      <OrganizationVisibilityForm
        role="Volunteer Coordinator"
        organizationIdentifier={organizationIdentifier}
      />
      <OrganizationVisibilityForm
        role="Volunteer"
        organizationIdentifier={organizationIdentifier}
      />
      <InviteUsers organizationIdentifier={organizationIdentifier} />
    </section>
  );
};

export default OrganizationCreation;
